import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./PopupForm.module.scss";
import PathContext from "../../context/path";
import IMask from 'imask';
const PopupForm = (props) => {
  const path = useContext(PathContext);
  const refWrap = useRef(null);
  const refOverlay = useRef(null);
  const refInputs = useRef([]);
  const { updateThemeInvert } = props;
  const [isSubmit, setSubmit] = useState(false);
  useEffect(() => {
    const tel = refInputs.current[3];
    const maskOptions = {
      mask: '+{7} (000) 000-00-00'
    };
    const mask = IMask(tel, maskOptions);
    tel.addEventListener('focus', function () {
      if (tel.value.trim() === '') {
        mask.value = '7';
        mask.updateOptions({ mask: '+{7} (000) 000-00-00' });
      }
    });

    tel.addEventListener('blur', function () {
      if (tel.value.trim() === '+7') {
        mask.updateOptions({ mask: '' });
      }
    });
  }, []);

  useEffect(()=>{
    const overlay = refOverlay.current;
    const wrap = refWrap.current;
    if(isSubmit){
      overlay.classList.add(styles.active);
      wrap.classList.add(styles.submited);
    }
  },[isSubmit]);
  
  const sumbitHandler = (e) => {
    e.preventDefault();
    if(isSubmit) return;
    setSubmit(true);
    let formData = new URLSearchParams();
    const inputs = refInputs.current;
    formData.append('name', 'contact-form');
    formData.append('pageId', '');
    formData.append('elementId', '');
    formData.append('source', window.location.href);
    formData.append('test', false);
    formData.append('fields[name]', inputs[0].value);
    formData.append('fields[Company%202]', inputs[1].value);
    formData.append('fields[email]', inputs[2].value);
    formData.append('fields[phone]', inputs[3].value);
    formData.append('fields[task]', inputs[4].value);
    formData.append('fields[source]', inputs[5].value);
    formData.append('dolphin', false);
    // const data = {
    //   'name': 'contact-form',
    //   'pageId': '',
    //   'elementId': '',
    //   'source': window.location.href,
    //   'test': false,
    //   'fields': {
    //     'name': inputs[0].value,
    //     'Company%202': inputs[1].value,
    //     'mail': inputs[2].value,
    //     'phone': inputs[3].value,
    //     'task': inputs[4].value,
    //     'source': inputs[5].value,
    //     'dolphin': false
    //   }
    // }
    const scriptURL = 'https://webflow.com/api/v1/form/61bc5f12164f845b8e80122d';

    fetch(scriptURL, {
      method: "POST",
      // headers: {
      //   'Content-Type': 'application/json;charset=utf-8'
      // },

      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: formData
    })
      .then(response => response.json())
      .catch((error) => console.error('Error!', error.message));
  }
  return (
    <>

      <form className={styles.wrap} ref={refWrap} onSubmit={sumbitHandler}>
        <div className={styles.overlay} ref={refOverlay}>
        Спасибо, ваша информация отправлена! Мы скоро с вами свяжемся.
        </div>
        <div className={styles.title}>Заполните форму, чтобы мы смогли предложить решение для вашей задачи и точную смету</div>
        <div className={styles.row}>
          <input type="text" name='name' id="name" placeholder="Имя" required ref={element => refInputs.current[0] = element} />
          <input type="text" name='company' id="company" placeholder="Компания" required ref={element => refInputs.current[1] = element} />
        </div>
        <div className={styles.row}>
          <input type="email" name='email' id="email" placeholder="Email" required ref={element => refInputs.current[2] = element} />
          <input type="tel" name='tel' id="tel" placeholder="Номер телефона" required ref={element => refInputs.current[3] = element} />
        </div>
        <textarea name="task" id="task" placeholder="Задача" required ref={element => refInputs.current[4] = element}></textarea>
        <input type="text" name='from' id="from" placeholder="Откуда вы узнали о нас" ref={element => refInputs.current[5] = element} />
        <button type="submit" className={styles.btn} onMouseOver={() => updateThemeInvert(true)} onMouseOut={() => updateThemeInvert(false)}>Отправить</button>
      </form>
    </>
  );

}

export default PopupForm;
